import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Link from "../components/Link"
import Seo from "../components/seo"
//import { renderRichText } from "gatsby-source-contentful/rich-text"
//import { options } from "../utils/richtext"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const StoriesPage = props => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCaseStory(sort: { id: DESC }) {
        edges {
          node {
            title
            id
            node_locale
            slug
            stories {
              slug
            }
          }
        }
      }
    }
  `)

  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Layout location={props.location}>
      <Seo title="Artikler" lang="da-DK" pathname="articles" />
      <div className="content">
        <Breadcrumb
          crumbs={crumbs}
          crumbSeparator=" / "
          crumbLabel={customCrumbLabel}
        />
      </div>
      <div className="content">
        <h1>Stories</h1>
        {data.allContentfulCaseStory.edges.map(edge => {
          if (edge.node.node_locale.toLowerCase() !== "da-dk") {
            return null
          }
          const firstRelatedStorySlug =
            edge.node.stories.length > 0
              ? edge.node.stories[0].slug
              : "no-related-story"

          return (
            <div className="article-card" key={edge.node.id}>
              <h4>
                <Link
                  to={`/stories/${edge.node.slug}/${firstRelatedStorySlug}`}
                >
                  {edge.node.title}
                </Link>
              </h4>
            </div>
          )
        })}
      </div>
    </Layout>
  )
}

export default StoriesPage
